import { render, staticRenderFns } from "./BtnCopy.vue?vue&type=template&id=ee16159e&"
import script from "./BtnCopy.vue?vue&type=script&lang=js&"
export * from "./BtnCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports